import {Component, ElementRef, ViewChild} from '@angular/core';
import { IonContent } from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';

import { NavService } from 'shared/nav/nav.service';
import { PerformancePanel } from '../performance-panel/performance-panel';
import { RecreationPanel } from '../recreation-panel/recreation-panel';
import { ResiliencePanel } from '../resilience-panel/resilience-panel';

@Component({
  selector: 'insights-page',
  templateUrl: 'insights-page.html',
  styleUrls: ['insights-page.scss'],
})
export class InsightsPage {

  @ViewChild(IonContent, {static: true}) public content: IonContent;

  constructor(
    public navService: NavService,
    public translateService: TranslateService) {
    }

}
